import { Marker } from "react-leaflet"
import * as L from 'leaflet';
import { useIcon } from "./Icon.hooks";
import { iconHtml } from "./utils";
import { MarkerInterface } from "../../../types";

export const Icon = ({ data, active, isMobile }: { data: MarkerInterface, isMobile: boolean, active?: boolean }) => {
  const icon = L.divIcon({
    className: 'abc',
    iconAnchor: active ? [30, 30] : [20, 20],
    html: iconHtml({ data, active }),
  })

  const { ref, position } = useIcon({ data, isMobile });

  return (
    <>
      <Marker
        position={position}
        icon={icon}
        ref={ref}
      />
    </>
  )
}
